module.exports = __webpack_public_path__ + "static/media/optical-biometry-ref.4f242329.png";